'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var MainContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (props) { return props.direction; }, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'baseline' : 'center');
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'flex-start' : 'center');
});
var templateObject_1;

exports.MainContainer = MainContainer;
